<template>
  <textarea ref="textarea" class="textarea" 
    :placeholder="placeholder"
    :value="value" 
    @input="e => { $emit('input', e.target.value) }"
    @focus="e => e.target.select()"></textarea>
</template>

<style scoped>
.textarea {
  flex: 1;
  border: 1px solid #eeeeee;
  background: white;
  padding: 5px 10px;
  box-sizing: border-box;
  min-height: 50px;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  resize: none;
  -webkit-transition: border-color 500ms ease-out;
  -moz-transition: border-color 500ms ease-out;
  -o-transition: border-color 500ms ease-out;
  transition: border-color 500ms ease-out;
}

.textarea:focus {
  outline-width: 0;
  border-color: #55be9d;
}

.textarea::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: lightgrey;
}
.textarea::-moz-placeholder {
  /* Firefox 19+ */
  color: lightgrey;
}
.textarea:-ms-input-placeholder {
  /* IE 10+ */
  color: lightgrey;
}
.textarea:-moz-placeholder {
  /* Firefox 18- */
  color: lightgrey;
}
</style>

<script>
export default {
  name: 'formTextarea',
  props: {
    value: String,
    placeholder: ''
  },
  methods: {
    focus() {
      this.$refs.textarea.focus()
      this.$refs.textarea.select()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/core/components/FormTextarea.vue